export const DEFAULT_ORIGIN_COUNTRY_CODE = 'CHN'

export const normalizeDraftProduct = (
  row: CalculationDocumentDraftProduct,
): CalculationDocumentDraftProduct => ({
  ...row,
  country_code: row.country_code || DEFAULT_ORIGIN_COUNTRY_CODE,
})
